import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AccountRepository } from '@timechef/features/account/state';

@Component({
  selector: 'app-greenscore-modal',
  templateUrl: './greenscore-modal.component.html',
  styleUrls: ['./greenscore-modal.component.scss'],
  standalone: false,
})
export class GreenscoreModalComponent {
  language$ = this.accountRepo.language$;

  constructor(
    private modalCtrl: ModalController,
    private accountRepo: AccountRepository,
  ) {}

  async dismissModal() {
    await this.modalCtrl.dismiss();
  }
}
